import isEmpty from "lodash/isEmpty";

export const getOmniStreamlined = (state) =>
  state.partnerDetails.partnerDetails.omniStreamlined;
export const getPartnerCode = (state) =>
  state.partnerDetails.partnerDetails.partnerCode;
export const getPartnerDetails = (state) => state.partnerDetails.partnerDetails;
export const partnerDetailsLoadedSelector = (state) =>
  state.partnerDetails.loading === false &&
  state.partnerDetails.error === false &&
  !isEmpty(state.partnerDetails.partnerDetails.experience);
export const getRoute = (state) => state.partnerDetails.partnerDetails.route;
export const getDisplayCode = (state) =>
  state.partnerDetails.partnerDetails.displayCode;
export const getAmazonConnectSelector = (state) =>
  state.partnerDetails.partnerDetails.amazonConnect;
